<template>
	<div class="row groups-row mx-0">
		<div class="d-flex flex-column col-md-3 px-0 border-right py-3">
			<div class="d-flex justify-content-center align-items-center">
				<button
					class="btn btn-primary create-new-group-button mb-3"
					@click="createNewGroup"
				>
					Create New Group
				</button>
			</div>
			<div class="px-2">
				<div class="input-and-submit-wrapper form-group d-flex align-items-center mb-3">
					<i class="fas fa-search form-icon"></i>
					<input
						type="text"
						class="form-control has-icon"
						id="group-name"
						v-model="groupSearchName"
						placeholder="Search Group"
					/>
				</div>
			</div>
			<div class="groups vertical-scroll">
				<div
					v-for="group in filteredGroups"
					:key="group.id"
					@click="selectGroup(group)"
					class="cursor-pointer px-2 py-2 group d-flex"
					:class="{ active: activeGroupId === group.id }"
				>
					<span class="col">{{ group.name }}</span>
				</div>
			</div>
		</div>
		<div class="col-md-9 view-group py-3 px-4">
			<div v-if="!activeGroupId">
				<p class="thin-title text-center">Please select a Group</p>
			</div>
			<div v-else>
				<manage-group
					:groupId="activeGroupId"
					@update-all="updateAll"
					@update-group-id="updateGroupId"
				/>
			</div>
			<div
				class="modal fade"
				id="newGroupModal"
				tabindex="-1"
				role="dialog"
				aria-labelledby="modalLabel"
				aria-hidden="true"
			>
				<div class="modal-dialog modal-dialog-centered" role="document">
					<div class="modal-content">
						<div class="modal-header">
							<h5 class="modal-title" id="modalLabel">Create New Group</h5>
							<button
								type="button"
								class="close"
								data-dismiss="modal"
								aria-label="Close"
							>
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
						<div class="modal-body">
							<input
								type="text"
								class="form-control"
								placeholder="Group Name"
								v-model="newGroupName"
							/>
						</div>
						<div class="modal-footer">
							<button type="button" class="btn btn-secondary" data-dismiss="modal">
								Close
							</button>
							<button type="button" class="btn btn-primary" @click="submitNewGroup">
								Submit
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import AdministrationMixin from './AdministrationMixin';
import ManageGroup from './ManageGroup';

export default {
	props: {
        partner: {
            type: Object,
            default: null,
        },
	},
	components: {
		ManageGroup,
	},
	mixins: [AdministrationMixin],
	data() {
		return {
			groups: [],
			activeGroupId: null,
			groupSearchName: '',
			showModal: false,
			newGroupName: '',
		};
	},
	computed: {
		filteredGroups() {
			const searchTerm = this.groupSearchName.toLowerCase();
			return this.groups.filter(
				(group) => !this.groupSearchName || group.name.toLowerCase().includes(searchTerm),
			);
		},
	},
	async mounted() {
		await this.fillInGroups();
	},
	methods: {
		async fillInGroups() {
			try {
				const response = await axios.get('/api/groups');
				this.groups = response.data;
			} catch (error) {
				console.error('Error fetching groups:', error);
			}
		},
		selectGroup(group) {
			this.activeGroupId = group.id;
		},
		updateAll() {
			this.fillInGroups();
		},
		updateGroupId() {
			this.activeGroupId = null;
			this.fillInGroups();
		},
		createNewGroup() {
			$('#newGroupModal').modal('show');
		},
		submitNewGroup() {
			if (this.newGroupName.trim()) {
				// Check for duplicate group name
				const duplicateGroup = this.groups.some(
					(group) => group.name.toLowerCase() === this.newGroupName.toLowerCase(),
				);

				if (duplicateGroup) {
					alert('A group with this name already exists. Please enter a different name.');
					return;
				}

				axios
					.post('/api/groups', {
						name: this.newGroupName,
					})
					.then((response) => {
						swal('Congrats!', 'Group Created Successfully', 'success');
						this.newGroupName = '';
						$('#newGroupModal').modal('hide');
						this.showModal = false;
						this.fillInGroups();
					})
					.catch(() => {
						$('#newGroupModal').modal('hide');
						this.showModal = false;
						this.fillInGroups();
					});
			} else {
				alert('Please enter a group name.');
			}
		},
	},
};
</script>

<style scoped>
.groups-row {
	height: 70vh;
	overflow-y: hidden;
}
.groups-row .col-md-3 {
	height: 100%;
}
.groups-row .col-md-3 .groups {
	max-height: calc(100% - 90px);
	overflow-y: auto;
}
.group {
	font-weight: 600;
	color: #90919e;
}
.group.active {
	color: #00aef1;
	font-weight: 600;
	box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.19);
}
.view-group {
	overflow-y: auto;
	max-height: 100%;
}
.modal {
	display: none;
}
</style>
